export default __webpack_public_path__ + "static/tdp-a5e3dea4cf7ba006d75262be9b83c42e.png";